<div class="container landing-container primary-page-wrapper">
  <app-business-detail-header [business]="businessDetails"></app-business-detail-header>
  <div class="ui-gallery-wrap">
    <h1 class="block-title">Gallery</h1>
    <app-gallery-img [items]="galleryImages"></app-gallery-img>
  </div>
</div>